import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";

const CSV_TEMPLATE = `nom;commune;codeInsee;codePostal;latitude;longitude;typeBatiment;typeProprietaire;surface;volumeBda;anneeLivraison;externalId
École primaire Jean Moulin;Grenoble;38185;38000;45.1885;5.7245;Scolaire;Publique;2500;450;2023;EXT-001
Immeuble résidentiel Les Pins;Chambéry;73065;73000;45.5646;5.9178;Logement;Privée;3200;680;2022;EXT-002
`;

export const CsvTemplateDownload = () => {
  const handleDownload = () => {
    const blob = new Blob([CSV_TEMPLATE], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "template_import_bda.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Button
      variant="outlined"
      startIcon={<Download />}
      onClick={handleDownload}
      size="small"
    >
      Télécharger le modèle CSV
    </Button>
  );
};
